var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.5341 4.26208L11.8137 11.1199C11.7181 11.2589 11.6668 11.4237 11.6668 11.5924V17.1667C11.6668 17.6268 11.2937 18 10.8335 18H9.16682C8.70657 18 8.33349 17.6268 8.33349 17.1667V11.5924C8.33349 11.4237 8.28224 11.259 8.18657 11.1199L3.46624 4.26208C3.09774 3.70667 3.54008 3 4.25633 3H15.7441C16.4602 3 16.9026 3.70667 16.5341 4.26208Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.1fe9544fbecddb6fa03985f6b7f034ad.svg";
export { ForwardRef as ReactComponent };